import type { HandlerType, LogsInitConfiguration } from "@datadog/browser-logs";
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import type { RumInitConfiguration } from "@datadog/browser-rum";

const datadogSite: LogsInitConfiguration["site"] = "datadoghq.eu";

const datadogLogParams: LogsInitConfiguration = {
    clientToken: "pubf0ffdea92d462ccd5a5c74700027c1cf",
    site: datadogSite,
    forwardErrorsToLogs: false,
    forwardConsoleLogs: [],
    forwardReports: [],
    sessionSampleRate: 100,
    service: "ghc-frontend",
};

const datadogRumParams: RumInitConfiguration = {
    applicationId: "7c269a0e-abfb-460a-9f11-d50ef10f0dda",
    clientToken: "pubf42ce21688e95d6e43138edfd8de72a6",
    site: datadogSite,
    service: "rum",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 1,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
        /^https?:\/\/(?![^/]*useinsider\.com)[^/]+\/api/,
        /^https?:\/\/[^/]+\/_next/,
    ],
};
const dataDogHandlers: HandlerType[] = ["http"];

export const initializeDatadog = () => {
    if (typeof window === "undefined") {
        // eslint-disable-next-line no-console
        console.error("Datadog can only be initialized in the browser");
        return;
    }

    const isLogsInitialized = typeof datadogLogs.getInitConfiguration() !== "undefined";
    const isRumInitialized = typeof datadogRum.getInitConfiguration() !== "undefined";

    if (!isLogsInitialized) {
        datadogLogs.init(datadogLogParams);
        datadogLogs.logger.setHandler(dataDogHandlers);
    } else {
        datadogLogs.logger.setHandler(dataDogHandlers);
    }

    if (!isRumInitialized) {
        datadogRum.init(datadogRumParams);
    }
};
